<template>
  <div>
    <Head @langChange="langSelect" />
    <section
      class="gameTop TopWarp"
      :style="{
        'background-color': '' + TopBgColor + '',
      }"
    >
      <img :src="TopUrl" alt="" />
      <div class="cont">
        <p class="p1" v-if="TopTitle != ''">{{ TopTitle }}</p>
        <p v-if="TopContent != ''">{{ TopContent }}</p>
      </div>
    </section>

    <section class="gameList cl">
      <div class="items" v-for="(item, index) in GameList" :key="index">
        <div class="item" v-if="item.pure_img == '1'">
          <a
            v-if="item.offical_url != ''"
            :href="item.offical_url"
            target="_blank"
          >
            <div class="img">
              <img :src="item.game_bg" alt="" />
            </div>
          </a>
          <div v-else>
            <div class="img">
              <img :src="item.game_bg" alt="" />
            </div>
          </div>
        </div>
        <div class="item" v-else-if="item.pure_img != '1'">
          <div class="logo">
            <img :src="item.game_logo" alt="" />
          </div>
          <div class="img">
            <img :src="item.game_bg" alt="" />
          </div>
          <div class="qrWarp">
            <p><img class="qr" :src="item.qr_code" alt="" /></p>
            <a :href="item.offical_url" target="_blank">
              {{ $t("btn.explore") }}</a
            >
          </div>
          <div class="cont">
            <p class="title">
              <a :href="item.offical_url" target="_blank" class="">
                <div class="ell2 title_g" v-html="item.game_title"></div>
              </a>
            </p>
            <div class="info">{{ item.offical_desc }}</div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部footer -->
    <Foot ref="foot"></Foot>
  </div>
</template>

<script>
import Head from "@/components/head.vue";
import Foot from "@/components/Foot.vue";
import { getGames } from "@/common/api.js";

export default {
  name: "Game",
  components: {
    Head,
    Foot,
    getGames,
  },
  data() {
    return {
      TopUrl: "",
      TopBgColor: "",
      TopTitle: "",
      TopContent: "",
      GameList: [],
      lang: this.$route.query.language || "zh",
    };
  },
  created() {
    this.getGame();
  },
  mounted() {},
  methods: {
    getGame() {
      let that = this;
      getGames({
        language: that.lang,
      }).then((res) => {
        if (res.status == 200) {
          let Data = res.data.data;
          that.TopUrl = Data.TopUrl;
          that.TopBgColor = Data.TopBgColor;
          that.TopTitle = Data.TopTitle;
          that.TopContent = Data.TopContent;
          that.GameList = Data.GameList;
        } else {
          console.log(res.statusText);
        }
      });
    },
    langSelect: function (param) {
      this.lang = param;
      this.getGame();
      this.$refs.foot.langSelect(param);
    },
  },
  computed: {},
};
</script>

<style scoped>
.gameList:after {
  content: "";
  width: 380px;
}
.gameList .item {
  position: relative;
  width: 100%;
  height: 100%;
  display: inline-block;
}
.gameList .item .logo {
  width: 130px;
  height: 75px;
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 2;
}
.gameList .item .logo img {
  width: 100%;
  height: 100%;
}
.gameList .item .img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  overflow: hidden;
  z-index: 1;
}
.gameList .item .img::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 70%;
  background-image: linear-gradient(
    to bottom,
    rgba(1, 1, 1, 0),
    rgba(1, 1, 1, 1)
  );
}
.gameList .item .img img {
  width: 100%;
  height: 100%;
}
.gameList .item .cont {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 150px;
  overflow: hidden;
  z-index: 3;
  background: #131313;
  color: #fff;
  width: 100%;
  text-align: left;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.gameList .item .cont .title {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 30px 20px 20px 20px;
}
.gameList .item .cont .title a {
  color: #fff;
}
.gameList .item .cont .info {
  /* width: 320px; */
  font-size: 16px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 18px;
  padding: 0 20px;
}
.gameList .item .qrWarp {
  opacity: 0;
  transition: all 0.3s;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  width: 100%;
  height: 350px;
  background: rgba(0, 0, 0, 0.65);
}
.gameList .item:hover .qrWarp {
  opacity: 1;
  transition: all 0.3s;
}

.gameList .item .qrWarp p {
  padding-top: 60px;
  padding-bottom: 35px;
}
.gameList .item .qrWarp a {
  border: 1px solid #fff;
  display: inline-block;
  width: 158px;
  height: 40px;
  border-radius: 5px;
  font-size: 18px;
  color: #fff;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
}
.gameList .item .qrWarp p img {
  width: 160px;
  height: 160px;
}
.title_g {
  white-space: pre-wrap; /* css-3 */
}
</style>





















































// WEBPACK FOOTER //
// src/views/Game.vue